export const selectionSortCode = {
    c: `
  void selectionSort(int arr[], int n) {
      for (int i = 0; i < n - 1; i++) {
          int min_idx = i;
          for (int j = i + 1; j < n; j++) {
              if (arr[j] < arr[min_idx]) {
                  min_idx = j;
              }
          }
          int temp = arr[min_idx];
          arr[min_idx] = arr[i];
          arr[i] = temp;
      }
  }`,
    cpp: `
  void selectionSort(int arr[], int n) {
      for (int i = 0; i < n - 1; i++) {
          int min_idx = i;
          for (int j = i + 1; j < n; j++) {
              if (arr[j] < arr[min_idx]) {
                  min_idx = j;
              }
          }
          std::swap(arr[min_idx], arr[i]);
      }
  }`,
    java: `
  public class SelectionSort {
      public static void selectionSort(int[] arr) {
          int n = arr.length;
          for (int i = 0; i < n - 1; i++) {
              int min_idx = i;
              for (int j = i + 1; j < n; j++) {
                  if (arr[j] < arr[min_idx]) {
                      min_idx = j;
                  }
              }
              int temp = arr[min_idx];
              arr[min_idx] = arr[i];
              arr[i] = temp;
          }
      }
  }`,
    python: `
  def selectionSort(arr):
      n = len(arr)
      for i in range(n - 1):
          min_idx = i
          for j in range(i + 1, n):
              if arr[j] < arr[min_idx]:
                  min_idx = j
          arr[i], arr[min_idx] = arr[min_idx], arr[i]
  `
  };
  